/**
 * Author:hong.rong
 * Desc:首页
 * Date:2022-02-27
 */
import styles from './index.module.less'
import 'swiper/swiper-bundle.css'
import 'swiper/swiper.less'
import React, { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import gioTrackEvent from '@/utils/gio'
import eventMap from '@/utils/gio/eventMap'
import { useTranslation } from '@/libs/next-lang'
import Advantage from './components/Advantage'
import Banner from './components/Banner'
import Cases from './components/Cases'
import Footer from './components/Footer'
import { homeButtonEnum, homeButtonList } from './index_enum'

export default function Dashboard({ bannerList }: any) {
  const router = useRouter()
  const upListRef = useRef([])
  const upListClickRef = useRef([])
  // const [eleList, setEleList] = useState([])
  const { t } = useTranslation(['dashboard', 'footer'])

  useEffect(() => {
    let elementsList = [] // 获取dom元素整合
    const options = {
      root: null, // 使用浏览器视窗作为根节点
      rootMargin: '0px', // 根节点的边距
      threshold: 1.0, // 目标元素完全可见时触发回调
    }
    const exposureLabel = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // 当目标元素进入视窗时触发的回调函数
        if (entry.isIntersecting) {
          if (
            !upListRef.current.includes(homeButtonEnum[entry.target.className.split(' ')[1]]) &&
            !upListRef.current.includes(homeButtonEnum[entry.target.className.split(' ')[2]])
          ) {
            // console.log(entry.target.className.split(' ').length,'看男单伟大我单位')
            if (entry.target.className.split(' ').length === 2) {
              // console.log('只上传一次')
              gioTrackEvent(eventMap.home_button_exposure_cz, {
                button_name: homeButtonEnum[entry.target.className.split(' ')[1]],
              })
              upListRef.current.push(homeButtonEnum[entry.target.className.split(' ')[1]])
            } else {
              gioTrackEvent(eventMap.home_button_exposure_cz, {
                button_name: homeButtonEnum[entry.target.className.split(' ')[2]],
              })
              upListRef.current.push(homeButtonEnum[entry.target.className.split(' ')[2]])
            }
          }
        }
      })
    }, options)
    homeButtonList.map(item => {
      const element = document?.querySelector(`.${item}`)
      elementsList = [element, ...elementsList]
    })
    // 为每个目标元素添加观察者
    elementsList.forEach(element => {
      // 鼠标点击事件发生时执行的操作
      element.addEventListener('click', function () {
        // 判断有咩有曝光点击 没有菜往下执行
        if (
          !upListClickRef.current.includes(element.classList[1]) &&
          !upListClickRef.current.includes(element.classList[2])
        ) {
          // 因为用了一些组件类名的长度不同有长度2长度3 要做区分
          if (element.classList.length === 2) {
            gioTrackEvent(eventMap.home_button_click_cz, {
              button_name: homeButtonEnum[element.classList[1]],
            })
            upListClickRef.current.push(element.classList[1])
          } else {
            gioTrackEvent(eventMap.home_button_click_cz, {
              button_name: homeButtonEnum[element.classList[2]],
            })
            upListClickRef.current.push(element.classList[2])
          }
        }
      })
      exposureLabel.observe(element)
    })
  }, [])

  /**
   * 路由跳转
   * @param pathname
   */
  const onRouteChange = (pathname: string) => {
    router.push(pathname)
  }

  return (
    <div className={styles.dashboard}>
      <div className={styles.wrap}>
        <div className={styles.container}>
          <Banner translateTxt={t} onRouteChange={onRouteChange} />
          <Cases dataSource={bannerList} translateTxt={t} onRouteChange={onRouteChange} />
          <Advantage translateTxt={t} onRouteChange={onRouteChange} />
        </div>
      </div>
      <Footer url="https://static.creativebooster.com/common/logo-w-h.svg" translateTxt={t} />
    </div>
  )
}
